import React, { useEffect, useState } from "react";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import { useTranslation } from "react-i18next";
import InputField from "../../components/shared/InputField";
import Button from "../../components/shared/Button";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import apiClient from "../../components/utils/apiClient";
import Loading from "../../components/shared/Loading";
import Toast from "../../components/shared/Toast";

const ResetPasswordPage = () => {

  const {i18n,t} = useTranslation();
  useDocumentTitle('pageTitles.login');
  const navigate = useNavigate();
  const [isFormSubmitDisabled,setIsFormSubmitDisabled] = useState(true);
  const [signInForm,setSignInForm] = useState({token:'',newPassword:''});
  const [errors, setErrors] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [token, setToken] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [toast, setToast] = useState({show: false,type: null, message:'' });

  useEffect(()=>{
    if(searchParams?.get("token")) {
      setToken(searchParams.get("token"));
      setSignInForm({ ...signInForm, token: searchParams.get("token") })
    }
  },[searchParams])



  const hideError = (err) => {
    if(errors) {
      let errorsList = errors;
      delete errorsList[err];
      setErrors(errorsList);
    }
  }

  useEffect(()=>{
    if(signInForm && signInForm?.newPassword && confirmPassword && JSON.stringify(confirmPassword) === JSON.stringify(signInForm?.newPassword)) {
      setIsFormSubmitDisabled(false);
    } else {
      setIsFormSubmitDisabled(true);
    }
  },[signInForm,confirmPassword])

  const handleClickChangePasswordButton = async () => {
    setIsFormSubmitDisabled(true);
    try {
      const response = await apiClient.post(`/b-users/reset-password`,Object.fromEntries(Object.entries(signInForm).filter(([_, v]) => v !== '')));
      if(response?.status === 200 || response?.status === 204 || response?.status === 201) {
        navigate(`/ar/reset-password-success`);
      }
    } catch(err) {
      setIsFormSubmitDisabled(false);
      if(err?.response?.data?.category === 'InvalidOrExpiredToken') {
        setToast({show:true,type:'error',message:'انتهت صلاحية الرابط من فضلك قم بطلب رابط تغيير جديد'});
      }
      if(err?.response?.data?.message) {
        let errorsList = {};
        errorsList.password = err?.response?.data?.message;
        setErrors(errorsList)
      } else {
        let errorsList = {};
        errorsList.OTP =err?.response?.data?.message;
        setErrors(errorsList);
      }
    }
  }
 

  // console.log(isFormSubmitDisabled);
  return (
    <div className="w-full">
      <h3 className="text-grey-900 font-[600] text-[32px] leading-[48px]">هلا بك في فني أعمال</h3>
      <p className="text-grey-600 font-[500] text-[18px] leading-[27px] mt-[15px] mb-[40px]">هنا يمكنك التحكم في إدارة و صيانة عقاراتك بكل سهولة و فعالية</p>
      {/* <p className="text-grey-900 font-[500] text-[18px] leading-[27px]">هل نسيت كلمة المرور؟</p> */}
      <div className="w-full max-w-[450px] pt-[40px]">
          <p className="text-grey-900 text-[18px] font-[500] mb-[30px]">من فضلك قم بإنشاء كلمة االمرور الجديدة.</p>
          <div className="mb-[20px]">
            <InputField type="password" label={'كلمة المرور الجديدة'} value={signInForm?.newPassword} error={errors?.newPassword} errorMessage={errors?.newPassword} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setSignInForm({ ...signInForm, newPassword: e.target.value }) }; hideError('newPassword')}} />
          </div>
          <div className="mb-[20px]">
            <InputField type="password" label={'تأكيد كلمة المرور'} value={confirmPassword} translateError={true} onChange={(e)=>{ if(e.target.value === '' || e.target.value) { setConfirmPassword(e.target.value) }}} />
          </div>
          <div className="mb-[35px]">
            <Button type="button" text={`تغيير كلمة المرور`} disabled={isFormSubmitDisabled} onClick={handleClickChangePasswordButton} />
          </div>
        {/* <p className="text-grey-600 text-[18px] font-[500] leading-[27px]">إذا كنت لا تمتلك حساب من فضلك قم  <Link className="text-blue font-[700]" to={process.env.REACT_APP_API_URL === 'https://beta-production-api.fanni.site' ? `https://business.fanni.sa/packages.html` : `https://staging-business.fanni.sa/packages.html`}>بإنشاء حساب جديد</Link>.</p> */}
      </div>

      <Toast toast={toast} setToast={setToast} />

      {!token && <Loading showLoading={true}/>}

    </div>
  );
};

export default ResetPasswordPage;
